<template lang="pug">
  .module__main
    .module__title Список претензий
    .module-content__container
      .categories__container
        el-radio-group(v-model="category")
          el-radio-button(label="opened") Активные
          el-radio-button(label="success") Успешные
          el-radio-button(label="reject") Отклоненные
          el-radio-button(label="canceled") Отмененные
          el-radio-button(label="error") Ошибка
      hr
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="getClaims.claims"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(prop="order_id" label="ID заявки" width="120")
              template(slot-scope="scope")
                span {{ `${scope.row.order_id} (${scope.row.deal_id})` }}
            el-table-column(prop="id" label="ID претензии" width="120")
            el-table-column(prop="fiat_amount_order" label="Сумма заявки" width="125")
            el-table-column(prop="fiat_amount" label="Сумма претензии" width="125")
            el-table-column(prop="payment_system" label="Платежная система" width="150")
            el-table-column(prop="created" label="Претензия создана" width="175")
            el-table-column(v-if="isErrorCategory" label="Ошибка")
              template(slot-scope="scope")
                span {{ scope.row.error }}
            el-table-column(v-if="isActionCategory" label="Действия")
              template(slot-scope="scope")
                el-button(size="mini"  type="danger" @click="editClaim(scope.row, 'cancel')" v-if="category === 'opened'").action__btn Отменить
                el-button(size="mini" @click="editClaim(scope.row, 'open')" v-else-if="category === 'reject'").action__btn Открыть заново
          el-dialog(
            :visible.sync="isClaimOpenActive"
            :before-close="resetClaimOpen"
            :title="`Открытие претензии по заявке №${claimOpenOrder.order_id}`"
            width="30%"
          )
            .h3 Введите сумму
            .exchange-finish__container
              .exchange-finish__input
                el-input(v-model="claimOpenAmount")
              .exchange-finish__buttons
                el-button(type="success" @click="openClaim(claimOpenOrder)") Подтвердить
                el-button(type="danger" @click="resetClaimOpen()") Отменить
          el-pagination(
            style="margin-top: 20px"
            v-if='hasPagination',
            :total='getClaims.pagination.count',
            :page-size="per_page",
            :current-page='getClaims.pagination.page',
            background,
            layout='prev, pager, next',
            @current-change='loadClaims'
          )
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import { LOAD_CLAIMS } from "../../store/const/claims";
import { EDIT_ORDER } from "../../store/const/orders";

export default {
  name: "ClaimsList",
  data() {
    return {
      intervalHandle: null,
      isCategoryChanged: false,
      isClaimsLoading: false,
      category: 'opened',
      page: 1,
      per_page: 50,
      isClaimOpenActive: false,
      claimOpenAmount: null,
      claimOpenOrder: {},
    }
  },
  watch: {
    category() {
      this.isCategoryChanged = true;
      this.page = 1;
      this.loadClaims();
    },
  },
  mounted() {
    this.loadClaims();
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('claims', {
      getClaims: 'claims',
    }),
    isLoading() {
      return this.isCategoryChanged && this.loading(LOAD_CLAIMS) === 'loading';
    },
    isError() {
      return this.loading(LOAD_CLAIMS) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_CLAIMS);
    },
    hasPagination() {
      let count = this.getClaims.pagination.count / this.getClaims.pagination.per_page;
      return this.getClaims.pagination.count && count > 1;
    },
    isActionCategory() {
      return this.category === 'opened' || this.category === 'reject';
    },
    isErrorCategory() {
      return this.category === 'error';
    }
  },
  methods: {
    ...mapActions('orders', {
      editOrder: EDIT_ORDER,
    }),
    ...mapActions('claims', {
      loadCurrentClaims: LOAD_CLAIMS,
    }),
    async loadClaims(page = 1) {
      if (!this.isClaimsLoading) {
        this.isClaimsLoading = true;
        await this.loadCurrentClaims({
          params: {
            page,
            per_page: this.per_page
          },
          category: this.category
        });
        this.isCategoryChanged = false;
        this.isClaimsLoading = false;
        this.page = page;
      }
    },
    startInterval(){
      this.intervalHandle = setInterval(() => this.loadClaims(this.page), 10000);
    },
    async editClaim(order, action) {
      this.$message.info('В разработке');
      return;
      // console.log('Try to edit claim:', order, action);
      // if (action === 'cancel') {
      //   await this.editClaimOrder({
      //     id: order.order_id,
      //     data: {
      //       claim: {
      //         ...order.claim,
      //         status: 'canceled',
      //         updated: Date.now(),
      //       }
      //     },
      //   }, 'Претензия успешно отменена');
      // } else if (action === 'open') {
      //   this.claimOpenAmount = order.order_fiat;
      //   this.claimOpenOrder = order;
      //   this.isClaimOpenActive = true;
      //   console.log('Try to open.,..', this.claimOpenAmount, this.isClaimOpenActive);
      // }
    },
    async editClaimOrder(editData, successMessage) {
      const request = await this.editOrder(editData);
      if (request.success) {
        this.$message({
          type: 'success',
          message: successMessage,
        });
      } else {
        this.$message({
          type: 'error',
          message: `Ошибка: ${request.message || 'Неизвестная ошибка'}`,
        });
      }
    },
    async openClaim(order) {
      await this.editClaimOrder({
        id: order.order_id,
        data: {
          status: 'claim',
          finished: false,
          claim: {
            status: 'new',
            fiat_amount: this.claimOpenAmount,
            created: Date.now(),
          }
        },
      }, 'Претензия успешно открыта');
    },
    resetClaimOpen() {
      this.claimOpenAmount = null;
      this.claimOpenOrder = {};
      this.isClaimOpenActive = false;
    },
  }
}
</script>
<style>
</style>
